import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-cancel', 'IconClockCancel', [
  ['path', { d: 'M20.997 12.25a9 9 0 1 0 -8.718 8.745', key: 'svg-0' }],
  ['path', { d: 'M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-1' }],
  ['path', { d: 'M17 21l4 -4', key: 'svg-2' }],
  ['path', { d: 'M12 7v5l2 2', key: 'svg-3' }],
]);
